import React from 'react';
import classNames from 'classnames';
import './index.scss';

export const NewsCard = ({ type, src, text, date }) => {
    return (
        <div
            className={classNames('runup-news-card', {
                'runup-news-card_big': type === 'big',
                'runup-news-card_revert': type === 'revert',
                'runup-news-card_inverse': type === 'inverse',
                'runup-news-card_vertical-big': type === 'vertical-big',
                'runup-news-card_vertical-middle': type === 'vertical-middle'
            })}
        >
            <div className='runup-news-card__image'>
                <img src={src} alt='news' />
            </div>
            <div className='runup-news-card__content'>
                <div className='runup-news-card__date'>{date}</div>
                <div className='runup-news-card__text'>{text}</div>
            </div>
        </div>
    );
};
